import React from 'react';
import { Card, Col } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { UploadFile } from '../File/UploadFile';

interface StampUploadSectionProps {
  title: string;
  file: string;
  setFile: (file: string) => void;
  buttonText: string;
}

export const StampUploadSection: React.FC<StampUploadSectionProps> = ({
  title,
  file,
  setFile,
  buttonText,
}) => {
  return (
    <Col md={6} className="mb-4">
      <Card>
        <Card.Header>
          <h6 className="mb-0">
            <Icon.FileEarmarkImage className="me-2" />
            {title}
          </h6>
        </Card.Header>
        <Card.Body className="text-center">
          <UploadFile
            file={file}
            setFile={setFile}
            buttonText={buttonText}
            imageHeight={100}
          />
        </Card.Body>
      </Card>
    </Col>
  );
};
